export default __webpack_public_path__ + "static/media/37.c1d18bdf.png";